import { Constants } from "../../../../../../../utils/constants"
import { Item, ObjectGeneric } from "../../../../../../../utils/types/generals"
import { calc30DaysAgo } from "../../indicators/methods/callEndpoints"

const formatTop15 = (payload: ObjectGeneric, order: 'asc' | 'desc') => {
    const { startDate, endDate } = calc30DaysAgo({
        end: payload?.to,
        start: payload?.from,
        format: Constants.dateEndpoint2
    })
    let filters: any = []

    if (payload?.from || payload?.to) {
        filters.push({
            "range": {
                [payload?.intervale?.value == '1w' ? 'fecha_inicio_semana' : 'fecha_inicio']: {
                    "gte": payload?.from ? startDate : null,
                    "lte": payload?.to ? endDate : null
                }
            }
        })
    }

    if (!!payload?.divisions?.length) {
        filters.push({
            terms: {
                division_id: (payload?.divisions as Item[])?.map(item => item.value),
            },
        })
    }

    if (!!payload?.units?.length) {
        filters.push({
            terms: {
                unidad_id: (payload?.units as Item[])?.map(item => item.value),
            },
        })
    }

    if (!!payload?.areas?.length) {
        filters.push({
            terms: {
                area_id: (payload?.areas as Item[])?.map(item => item.value),
            },
        })
    }
    if (!!payload?.departments?.length) {
        filters.push({
            terms: {
                departamento_id: (payload?.departments as Item[])?.map(item => item.value),
            },
        })
    }
    
    if (!!payload?.questionnaire?.length) {
        filters.push({
            terms: {
                cuestionario_id: (payload?.questionnaire as Item[])?.map(item => item.value),
            },
        })
    }
    if (!!payload?.users?.length) {
        filters.push({
            terms: {
                usuario_id: (payload?.users as Item[])?.map(item => item.value),
            },
        })
    }
    if (!!payload?.percentage?.length) {
        filters.push({
            range: {
                avance: {
                    gte: payload?.percentage?.[0],
                    lte: payload?.percentage?.[1],
                },
            },
        })
    }

    if (payload?.estatus && (Array.isArray(payload?.estatus) ? payload?.estatus?.length > 0 : payload?.estatus)) {
        const estatusValues = Array.isArray(payload?.estatus) 
            ? (payload?.estatus as Item[])?.map(item => item.value)
            : [payload?.estatus?.value || payload?.estatus];
        
        filters.push({
            terms: {
                estatus_id: estatusValues,
            },
        })
    }

    const body = {
        size: 30,
        query: {
            bool: {
                filter: filters,
            },
        },
        "aggs": {
            "registros_diarios": {
                "terms": {
                    "field": "unidad_id",
                    "size": 30,  // Tamaño máximo de términos a devolver
                    "order": {
                        "promedio_avance": order  // Ordenar los términos por el valor promedio de "avance" en orden descendente
                    }
                },
                "aggs": {
                    "promedio_avance": {
                        "avg": {
                            "field": "avance",
                        },
                    },
                    "cuestionario_resultado": {
                        "avg": {
                            "field": "cuestionario_resultado",
                        },
                    },
                },
            }      
        }
    }

    return {
        body
    }
}

export { formatTop15 }